import type { TreeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";

export const expandAll = (treeApi: TreeApi<Node>) => {
  if (!treeApi) {
    throw new Error("Tree API is not available. Cannot expand level.");
  }
  treeApi.openAll();
  return {} as Record<string, boolean>;
};
